import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=0cfc0a6b&scoped=true&"
import script from "./Master.vue?vue&type=script&lang=ts&"
export * from "./Master.vue?vue&type=script&lang=ts&"
import style0 from "./Master.vue?vue&type=style&index=0&id=0cfc0a6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfc0a6b",
  null
  
)

export default component.exports